import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {LocalStorageService} from "./storage.service";
import {LoadingController} from "@ionic/angular";


@Injectable(
  {providedIn: 'root'}
)
export class ImageService {

  private authTokenStorageEntity: string = 'authtokens';

    constructor(
        private api: ApiService,
        private http: HttpClient,
        private localStorage: LocalStorageService,
        private loadingCtrl: LoadingController
    ) { }

    async uploadImage(fileData: any, fileName: string, privateImage: boolean, accountId: number = 0) {
        const loader = await this.loadingCtrl.create({
            message: 'Uploading image...'
        });
        await loader.present();

        console.log(`Uploading image: ${accountId}, ${privateImage},${fileName}, ${fileData}`);
        try {
            const formData = new FormData();
            formData.append('file', fileData, fileName);
            if (accountId > 0) {
                //upload secure document
                return await this.api.post<string>(
                    `${this.api.endpoints.images}/uploadPrivateAccountDocument?fileName=${fileName}&accountId=${accountId}`, 
                    formData, 
                    true,
                    '');
            } else {
                return await this.api.post<string>(
                    `${this.api.endpoints.images}/uploadFile?privateFile=${privateImage}`,
                    formData, 
                    true,
                    '');
            }
        } catch (err) {
            console.error(err);
            throw err;
        } finally {
            await loader.dismiss();
        }
    }

    async getPrivateAccountDoc(fileName: string, accountId: number): Promise<{ url: string }> {
        return this.api.get(this.api.endpoints.images + '/getPrivateAccountDocument?fileName=' + fileName + '&accountId=' + accountId);
    }

    uploadFile(file: any, fileName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            this.localStorage.getEntity(this.authTokenStorageEntity)
                .then(async tokens => {
                    var headers = new HttpHeaders();
                    headers = await this.api.getHeaders(true, "");
                    console.log('headers', headers);
                    let formData: FormData = new FormData();
                    formData.append('file', file, fileName);

                    this.http.post(this.api.endpoints.images +  '/uploadFile', formData, { headers: headers })
                        .subscribe(data => {
                            resolve(data as string);
                        }
                            , error => {
                                reject(error);
                            });
                });
        });
    }

    async downloadSecureDocumentsBulk(filters: any, zipFileName: string) {
        await this.api.getFileContents(`${this.api.endpoints.images}/GetSecureDocumentsBulk?zipFileName=${zipFileName}`, filters);
    }

    async getRequiredDocument(fileName: string): Promise<{ url: string }> {
        return this.api.get(this.api.endpoints.images + '/getRequiredOrgDocument?fileName=' + fileName);
    }

}
